// The only colors a restaurant may pick for the business card's back
// (background + text). Mirrors CARD_SAFE_PALETTE_HEXES in backend/src/index.ts
// exactly: every entry was chosen to already sit inside CMYK gamut, so
// there's nothing to lose converting them for print. See QR_PRINT_PLAN.md
// §2.4. `nameKey` resolves under the `cardDesign.colors` i18n namespace.
export interface CardPaletteColor {
  hex: string;
  nameKey: string;
}

export const CARD_PALETTE: CardPaletteColor[] = [
  // Neutrals
  { hex: '#FFFFFF', nameKey: 'white' },
  { hex: '#E0E0E0', nameKey: 'lightGray' },
  { hex: '#B0B0B0', nameKey: 'gray' },
  { hex: '#808080', nameKey: 'mediumGray' },
  { hex: '#5A5A5A', nameKey: 'slate' },
  { hex: '#333333', nameKey: 'charcoal' },
  { hex: '#1A1A1A', nameKey: 'black' },
  // Reds/pinks/purples
  { hex: '#B33A3A', nameKey: 'brickRed' },
  { hex: '#C1654A', nameKey: 'terracotta' },
  { hex: '#C97B84', nameKey: 'dustyRose' },
  { hex: '#A97C9A', nameKey: 'mauve' },
  { hex: '#7B4B94', nameKey: 'plum' },
  { hex: '#6C4F9E', nameKey: 'violet' },
  { hex: '#3E3A6E', nameKey: 'indigo' },
  // Blues/teals
  { hex: '#1F5F5B', nameKey: 'deepTeal' },
  { hex: '#2E8B8B', nameKey: 'steelTeal' },
  { hex: '#6FB8A8', nameKey: 'seafoam' },
  { hex: '#6B8FD2', nameKey: 'cornflower' },
  { hex: '#2A4E8C', nameKey: 'royalBlue' },
  { hex: '#1B2A4A', nameKey: 'navy' },
  { hex: '#14213D', nameKey: 'midnight' },
  // Greens/yellows/oranges
  { hex: '#1E4D3A', nameKey: 'forestGreen' },
  { hex: '#7A9B76', nameKey: 'sage' },
  { hex: '#B5A642', nameKey: 'oliveGold' },
  { hex: '#C9962C', nameKey: 'mustard' },
  { hex: '#D98E4A', nameKey: 'apricot' },
  { hex: '#C1622B', nameKey: 'burntOrange' },
  { hex: '#B44A2E', nameKey: 'rust' },
];
